<template>
  <li class="checkout-summary-literal" role="presentation">
    <div class="text">{{ text }}</div>
  </li>
</template>

<script>
export default {
  name: 'CheckoutSummaryLiteral',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.checkout-summary-literal {
  .text {
    font-size: $font-size-sm;
    color: $gray-700;
    line-height: 1.35;
  }
}
</style>
